export default {
  FETCH_DAPI_TOKEN: {
    errorCode: 'fetch_dapi_token',
    body: 'AUTH0-LOGIN-ERROR-01::Auth0 error in receiving jwt token.',
  },
  INITIALISE_USER_SESSION: {
    errorCode: 'initialise_user_session',
    body: 'AUTH0-LOGIN-ERROR-02::Auth0 error in initialising user session.',
  },
  AUTH0_CHECK_SESSION: {
    errorCode: 'auth0_check_session',
    body:
      'AUTH0-LOGIN-ERROR-03::Auth0 error in checking session for access token and its expiration date.',
  },
  AUTH0_DECODE_HASH: {
    errorCode: 'auth0_decode_hash',
    body: 'AUTH0-LOGIN-ERROR-04::Auth0 library unable to decode hash.',
  },
  AUTH0_INVALID_AUTH_RESULT: {
    errorCode: 'auth0_invalid_auth_result',
    body: 'AUTH0-LOGIN-ERROR-05::Auth0 invalid auth result.',
  },
  AUTH0_BLOCKED: {
    errorCode: 'auth0_blocked',
    body: 'AUTH0-LOGIN-ERROR-06::Auth0 unauthorized',
  },
  AUTH0_TIMEOUT: {
    errorCode: 'auth0_timeout',
    body: 'AUTH0-LOGIN-ERROR-07::Auth0 login timeout',
  },
};
